import type { ReactNode } from 'react'

import { ConfirmDialog } from '@/components/molecules/confirm-dialog.molecule'

export interface AgentNodeUnsavedChangesDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * Confirmation dialog shown when attempting to close the agent node drawer with unsaved changes.
 */
export const AgentNodeUnsavedChangesDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: AgentNodeUnsavedChangesDialogProps): ReactNode => (
  <ConfirmDialog
    isOpen={isOpen}
    onOpenChange={(open) => !open && onClose()}
    title="Unsaved Changes"
    description="You have unsaved changes. Are you sure you want to close without saving?"
    confirmLabel="Close Without Saving"
    cancelLabel="Keep Editing"
    onConfirm={onConfirm}
    variant="destructive"
  />
)

AgentNodeUnsavedChangesDialog.displayName = 'AgentNodeUnsavedChangesDialog'
